module.exports = __webpack_public_path__ + "img/j.eac6788f.jpg";